"use client";

import Loading from "@/components/Loading";
import BetOKThreeColSection from "./BetOKThreeColSection";
import BetOKCorrectScoresSection from "./BetOKCorrectScoresSection";
import "./index.css";

export default function BetOKOtherBetsDropdown({
  loadingOtherOdds,
  otherOddsData,
  hasOtherData,
  correctScoresListFull = [],
  correctScoresFull = { home: [], draw: [], away: [] },
  totalCornersOdds = [],
  odds = {},
  showOther,
}) {
  return (
    <div className={`kbv-v25-odt-wrapper min-w-0 overflow-hidden ${showOther ? "kbv-v25-odt-wrapper--active" : ""}`}>
      {loadingOtherOdds && !otherOddsData && (
        <div className="w-full py-4">
          <Loading />
        </div>
      )}
      {!loadingOtherOdds && otherOddsData && !hasOtherData && (
        <div className="kbv-v25-odt-empty">Chưa có dữ liệu kèo cược khác</div>
      )}
      {!loadingOtherOdds && hasOtherData && (
        <div className="kbv-v25-odt-table">
          <div className="flex flex-wrap gap-1 md:gap-y-[10px] md:gap-x-4">
            <BetOKThreeColSection
              title="Kèo phạt góc"
              items={[
                { label: "Đội nhà", value: totalCornersOdds?.[0]?.over, trend: totalCornersOdds?.[0]?.initialOverTrend },
                { label: "Đội khách", value: totalCornersOdds?.[0]?.under, trend: totalCornersOdds?.[0]?.initialUnderTrend },
                { label: "Hòa", value: null },
              ]}
              width="kbv-v25-odt-item--100"
            />

            <BetOKThreeColSection
              title="FT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeEuropeOdds, trend: odds?.homeEuropeTrend },
                { label: "Đội khách", value: odds?.awayEuropeOdds, trend: odds?.awayEuropeTrend },
                { label: "Hòa", value: odds?.instantDrawOdds, trend: odds?.drawTrend },
              ]}
              width="kbv-v25-odt-item--50"
            />

            <BetOKThreeColSection
              title="HT 1x2"
              items={[
                { label: "Đội nhà", value: odds?.homeHandicapHalfOdds, trend: odds?.homeHandicapHalfTrend },
                { label: "Đội khách", value: odds?.awayHandicapHalfOdds, trend: odds?.awayHandicapHalfTrend },
                { label: "Hòa", value: null },
              ]}
              width="kbv-v25-odt-item--50"
            />

            {correctScoresListFull.length > 0 && (
              <BetOKCorrectScoresSection
                title="Tỷ số chính xác toàn trận"
                correctScoresFull={correctScoresFull}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
